module.exports = require('./components/Modal');




/** WEBPACK FOOTER **
 ** ./~/react-modal/lib/index.js
 **/